/*
 * MDB shim for MDBSelectOption
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 */

import MUIMenuItem from "@mui/material/MenuItem";

export default function MDBSelectOption({ children, value, ...rest }) {
    return (
        <MUIMenuItem value={value} {...rest}>
            {children}
        </MUIMenuItem>
    );
}
